<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- <el-menu
      default-active="2"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose">
      <div v-for="(route,index) in permission_routes" :key="index" >
        <el-submenu :index="route.path" v-if="!route.hidden">
          <template slot="title">
            <img src="../../../assets/router/1.png">
            <span>{{route.meta?route.meta.title:'未设置父路由名称'}}</span>
          </template>
          <el-menu-item-group>
            <div v-for="(item,i) in route.children" :key="i">
                <el-menu-item :index="index+'-'+i" v-show="!item.hidden" @click="pushRoute(route.path,item.path)">{{item.meta?item.meta.title:'未设置子路由名称'}}</el-menu-item>

            </div>
          </el-menu-item-group>
        </el-submenu>
      </div>

    </el-menu> -->
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import role from "../../../router/index";

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      permission_routes: JSON.parse(localStorage.getItem("routes")),
      userModel: localStorage.getItem("userModel"),
      apiSwitch: localStorage.getItem("apiSwitch")
    };
  },
  computed: {
    ...mapGetters([
      // 'permission_routes',
      "sidebar"
    ]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  created() {
    // 这样维护很不优秀，后续需要优化
    // 对接信息按钮隐藏 1是开通过，2是未开通
    if (this.apiSwitch === "2") {
      role.options.routes[16].children[2].hidden = true;
    } else {
      role.options.routes[16].children[2].hidden = false;
    }
  }
};
</script>

<style scoped></style>
